import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useEntitlements } from "../lib/entitlements";

// Backend is the source of truth (every protected API returns 401/402); this guard
// just keeps the UI consistent so refreshes / direct URLs / new tabs can't show the
// tool to a non-subscriber.
export default function RequireEntitlement({ children }) {
  const location = useLocation();
  const { status } = useAuth();
  const { is_pro, loaded } = useEntitlements();

  if (status === "loading" || !loaded) {
    return (
      <div style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
        <Loader2 size={32} className="spin" color="var(--brand)" />
      </div>
    );
  }

  if (!is_pro) {
    return <Navigate to="/paywall" replace state={{ from: location.pathname }} />;
  }

  return children;
}
